<template>
  <div id="app" :class="{'--offer-active' : showOffer}">
    <div v-if="!wpData">
      <section class="s-section s-section--top">
        <div class="s-block s-block--center">
          <div class="s-spinner">
            <div class="s-spinner__left"></div>
            <div class="s-spinner__right"></div>
          </div>
        </div>
      </section>
    </div>
    <div v-if="wpData">
      <div class="s-shop-select">
        <h1 class="s-heading s-heading--2">
          <span class="s-heading__text">{{ introText }}</span>
        </h1>
        <Legals/>
        <OfferToggle v-if="showOfferToggle"/>
        <StepNavigation />
        <Offer v-if="showOffer"/>
        <StepStreaming v-if="!showOffer"/>
        <StepAnalyse v-if="!showOffer"/>
        <StepCamera v-if="!showOffer"/>
        <StepPreorder v-if="!showOffer"/>
        <StepAddress/>
      </div>
      <StickyBar/>
    </div>
  </div>
</template>

<script>
import StepNavigation from './components/StepNavigation.vue'
import StickyBar from "./components/StickyBar";
import StepStreaming from "./components/StepStreaming";
import StepAnalyse from "./components/StepAnalyse";
import StepAddress from "./components/StepAddress";
import StepCamera from "./components/StepCamera";
import StepPreorder from "./components/StepPreorder";
import Legals from "./components/Legals";
import OfferToggle from "./components/OfferToggle.vue";
import Offer from "./components/Offer.vue";

export default {
  name: 'App',
  components: {
    OfferToggle,
    Offer,
    Legals,
    StepCamera,
    StepAnalyse,
    StepStreaming,
    StepPreorder,
    StickyBar,
    StepNavigation,
    StepAddress
  },
  computed: {
    wpData() {
      return this.$store.getters.wpdata;
    },
    introText(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_other[0].slang_intro;
    },
    showOffer(){
      return this.$store.state.showOffer && this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    },
    showOfferToggle(){
      return this.$store.state.wpdata[wpGlobalData.language].offer.activate_offer;
    }
  },
  async created() {
    await this.$store.dispatch('loadWpdata');
    await this.$store.commit('setAnalyseOption', this.$store.getters.getInitialAnalyseData(wpGlobalData.language));
    await this.$store.commit('setCameraOption', this.$store.getters.getInitialCameraData(wpGlobalData.language));
    await this.$store.commit('setFullPriceData');
    this.viewportCheck('.s-shop-select__item');
  },
  watch: {
    showOffer() {
      setTimeout(() => {
        this.viewportCheck('.s-shop-select__item');
      }, "1000")
    }
  },
  methods:{

    viewportCheck(els) {
      let elements = document.querySelectorAll(els);
      console.log(elements);
      let nav = document.querySelectorAll('.s-step');
      for (let i = 0; i < elements.length; i++) {
        if (this.isInView(elements[i])) {
          this.handleActiveState(elements,i,nav);
        }
        window.addEventListener("scroll", () => { this.scrollCallback(elements,i,nav) }, false);
      }
    },

    scrollCallback(elements,i,nav) {
      if (this.isInView(elements[i]) && !elements[i].classList.contains('--is-active')) {
        this.handleActiveState(elements,i,nav);
      }
    },

    handleActiveState(elements,i,nav) {
      Array.prototype.forEach.call(elements, node => {
        node.classList.remove('--is-active');
      });
      elements[i].classList.add('--is-active');
      let videos = elements[i].getElementsByTagName('video');
      if(videos.length > 0){
        for (const video of videos){
          video.currentTime = 0;
        }
      }
      Array.prototype.forEach.call(nav, (node, index) => {
        node.classList.remove('--is-current','--is-complete');
        if(i === index){
          node.classList.add('--is-current');
        }else if(i > index){
          node.classList.add('--is-complete');
        }
      });
    },

    isInView(el) {
      let scrollTop = window.scrollY;
      let top = window.pageYOffset + (el.getBoundingClientRect().top - (window.innerHeight / 2));
      let bottom = window.pageYOffset + (el.getBoundingClientRect().bottom- (window.innerHeight / 2))
      if(el.dataset.stepContent === "01"){
        return (
          bottom > scrollTop
        );
      }else{
        return (
          top < scrollTop && bottom > scrollTop
        );
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue